import {
  typeConverter,
  useFirestore,
  useFirestoreSnapshot,
} from '@goschool/react-firebase'
import type { User } from 'firebase/auth'
import { useMemo } from 'react'
import { doc } from 'firebase/firestore'
import type { GoSchoolUser } from '../GoSchoolUser'

export function useGoSchoolUser(user: User | null | undefined) {
  const firestore = useFirestore()
  const ref = useMemo(() => {
    if (user === undefined) {
      return undefined
    } else if (user == null) {
      return null
    } else {
      return doc(firestore, 'users', user.uid).withConverter(
        typeConverter<GoSchoolUser>()
      )
    }
  }, [user, firestore])
  const snapshot = useFirestoreSnapshot(ref)
  return snapshot
}
